import { Antiquity } from './Antiquity';
import { CoveredSurface } from './CoveredSurface';
import { Description } from './Description';
import { Expenses } from './Expenses';
import { MinusPlusInput } from './MinusPlusInput';
import { Price } from './Price';
import { TotalSurface } from './TotalSurface';
import { Laundry } from './Laundry';
import { Balcony } from './Balcony';
import { Yard } from './Yard';
import { Rooftop } from './Rooftop';
import { Garages } from './Garages';
import { BuildingStage } from './BuildingStage';
import { BuildingLocationInBlock } from './BuildingLocationInBlock';
import { BuildingCeilingHeight } from './BuildingCeilingHeight';
import { BuildingAntiquity } from './BuildingAntiquity';
import { BuildingCategory } from './BuildingCategory';
import { BuildingBrightness } from './BuildingBrightness';
import { BuildingOrientation } from './BuildingOrientation';
import { BuildingDisposition } from './BuildingDisposition';
import { BuildingState } from './BuildingState';
import { BuildingType } from './BuildingType';

export const inputs = {
  Antiquity,
  CoveredSurface,
  Description,
  Expenses,
  MinusPlusInput,
  Price,
  TotalSurface,
  Laundry,
  Balcony,
  Yard,
  Rooftop,
  Garages,
  BuildingStage,
  BuildingLocationInBlock,
  BuildingCeilingHeight,
  BuildingAntiquity,
  BuildingCategory,
  BuildingBrightness,
  BuildingOrientation,
  BuildingDisposition,
  BuildingState,
  BuildingType
};
